import * as React from "react";
const SvgFiRrPersonSign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22 0h-5c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h1.5v3h-5L12 8a5.03 5.03 0 0 0-4-2H6c-2.206 0-4 1.794-4 4v3c0 1.474.81 2.75 2 3.444V23a1 1 0 1 0 2 0v-6h2v6a1 1 0 1 0 2 0V12a1 1 0 1 0-2 0v3H6c-1.103 0-2-.897-2-2v-3c0-1.103.897-2 2-2h2c.939 0 1.836.449 2.4 1.2l1.8 2.4a1 1 0 0 0 .8.4h5.5c1.103 0 2-.897 2-2V7H22c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2m-5 5V2h5v3zM4.5 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
    />
  </svg>
);
export default SvgFiRrPersonSign;
